import React from 'react';
import { z } from 'zod';
import { patientOverviewActions } from './constants';

export const modalDataSchema = z
  .discriminatedUnion('modalName', [
    z.object({
      modalName: z.literal('UpdateScriptRemains'),
      healthCategory: z.string(),
      productId: z.string(),
      pharmacyId: z.string(),
    }),
    z.object({
      modalName: z.literal('TransferScript'),
      healthCategory: z.string(),
      productId: z.string(),
    }),
    z.object({
      modalName: z.literal('RemoveScript'),
      healthCategory: z.string(),
      productId: z.string(),
    }),
    z.object({
      modalName: z.literal('EscriptCreationEdit'),
      productId: z.string(),
      productName: z.string(),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('CreateScript'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('AddToCatalogue'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('SendForPrescribing'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('CreatePhoneCall'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('CheckPhoneCall'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('FormViewer'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('SendDoctorLetter'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('RejectPatient'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('MarkConsultComplete'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('RetryNvpCanviewSend'),
      healthCategory: z.string(),
      consultationId: z.string().nullable(),
    }),
    z.object({
      modalName: z.literal('MarkCheckupComplete'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('MarkPayment'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('ResetForm'),
      healthCategory: z.string(),
    }),
    z.object({
      modalName: z.literal('RefundConsult'),
      healthCategory: z.string(),
      /** Present for nicotine consults — carries the consultation's orderId directly. */
      lastPaymentReference: z.string().optional(),
    }),
    z.object({
      modalName: z.literal('UpdateDispense'),
      healthCategory: z.string(),
      productId: z.string(),
    }),
    z.object({
      modalName: z.literal('SUCCESS'),
      message: z.string(),
    }),
    z.object({
      modalName: z.literal('ERROR'),
      message: z.string(),
    }),
  ])
  .or(
    z.object({
      modalName: z.enum(patientOverviewActions),
    }),
  );

/**
 * @type {React.Context<import('./PatientProvider').PatientProviderValue | undefined>}
 */
export const PatientContext = React.createContext(
  /** @type {import('./PatientProvider').PatientProviderValue | undefined} */
  (undefined),
);
